export default {
    admin: {
        title: 'administración',
        superadmin: {
            title: 'super administrador',
            edit: 'editar'
        },
        invite: {
            manage: 'Invitar a embajadoras de la comunidad.',
            resend: 'revender',
            resend_success: 'La invitación ha sido resentida',
        },
        events: {
            edit: {
                singular: 'Evento de edición',
                plural: 'editar eventos',
            },
            overview: 'eventos',
        },
        organizations: {
            edit: {
                singular: 'Editar organización y marca',
                plural: 'editar organizaciones y marcas',
            },
            overview: 'organizaciones y marcas',
        },
        pages: {
            edit: {
                singular: 'Página de edición',
                plural: 'editar páginas',
            },
            update: {
                success: 'Página actualizada',
                singular: "Página de actualización",
                title: "título",
                content: "contenido",
                update_success: "página actualizada correctamente"
            },
            overview: 'páginas',
            title: 'título',
            content: 'contenido',
        },
        prices: {
            update: {
                success: 'Precios actualizados',
                singular: "Actualizar precios",
                title: "título",
                content: "contenido",
                update_success: "Precios actualizados con éxito"
            },
            success: 'Compra exitosa',
        },
        users: {
            edit: {
                singular: 'editar usuario',
                plural: 'editar usuarios',
            },
            active: 'Activo',
            passive: 'Pasivo',
            overview: 'usuarias',
            impersonate: {
                button: 'Suplantar',
                loading: 'Suplantando...',
                error: 'No se pudo suplantar a este usuario.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Enlaces de envío',
            intro: 'Enlaces con los que los organizadores envían un evento sin cuenta.',
            new: 'Nuevo enlace',
            new_hint: 'Crea un enlace para dar a un organizador por WhatsApp o correo.',
            create: 'Crear enlace',
            created: 'Enlace creado',
            search: 'Buscar',
            copy: 'Copiar enlace',
            withdraw: 'Retirar',
            reactivate: 'Reactivar',
            no_brand: 'Sin marca todavía',
            empty: 'Aún no hay enlaces.',
            failed: 'Algo salió mal.',
            has_submissions: 'Ya llegaron envíos por este enlace; retíralo en vez de borrarlo.',
            delete_confirm: '¿Eliminar el enlace {code}?',
            fields: {
                code: 'Código',
                label: 'Descripción',
                label_placeholder: 'p. ej. Salsa Nights Rotterdam',
                brand: 'Marca',
                brand_placeholder: 'Buscar una marca',
                brand_hint: 'Opcional. Decide a qué marca pertenece el envío.',
                state: 'Estado',
                submissions: 'Envíos',
                expires_at: 'Caduca el',
                max_submissions: 'Máx. envíos',
                contact_name: 'Contacto',
                contact_email: 'Correo electrónico',
            },
            states: {
                all: 'Todos',
                active: 'Activo',
                expired: 'Caducado',
                withdrawn: 'Retirado',
                full: 'Lleno',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Marca', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Estado de la marca' },

            brand_status: {
                unchecked: 'Aún sin comprobar',
                unmatched: 'Aún no está en LatinMap',
                unmanaged: 'Existe, sin gestionar',
                review: 'Revisar',
                managed: 'Gestionada',
            },
            match_signal: {
                email: 'encontrada por correo',
                domain: 'encontrada por sitio web',
                name: 'encontrada por nombre',
                name_city: 'encontrada por nombre + ciudad',
                fuzzy: 'nombre parecido — revisar',
            },
            unlink_brand: 'Desvincular marca',
            organization_unlinked: 'Marca desvinculada',
            unlink_confirm: {
                title: '¿Desvincular marca?',
                submit: 'Sí, desvincular',
                body: '¿Quitar el vínculo entre "{event}" y la marca "{brand}"?',
                note: 'El concepto permanece en la lista y puede vincularse a otra marca. No se elimina nada.',
            },
            link_confirm: {
                title: '¿Vincular marca?',
                submit: 'Sí, vincular',
                body: '¿Vincular "{event}" a la marca "{brand}"? El evento aún debe aprobarse por separado.',
                signal: 'Encontrado:',
                warning_managed: 'Esta marca la gestiona activamente un Professional. Vincular un evento extraído puede chocar con su propio trabajo.',
                warning_review: 'Esta coincidencia no es segura. Comprueba que realmente sea la misma marca antes de vincular.',
            },
            link_match: 'Vincular esta marca',
            refresh_matches: 'Actualizar coincidencias',
            refresh_matches_help: 'Recalcular a qué marcas existentes pertenecen los organizadores extraídos',
            matches_refreshed: 'Coincidencias actualizadas: {certain} seguras, {possible} por revisar',
            bulk: {
                selected: '{count} seleccionados',
                link_matched: 'Vincular marca encontrada',
                approve: 'Aprobar',
                reject: 'Rechazar',
                clear: 'Borrar selección',
                running: 'Procesando...',
                select_all: 'Seleccionar todo en esta página',
                select_one: 'Seleccionar {name}',
                nothing_to_link: 'Nada en la selección tiene una coincidencia segura',
                nothing_to_unlink: 'Nada en la selección tiene una marca vinculada',
                unlink: 'Desvincular',
                result: '{succeeded} procesados, {failed} omitidos',
                confirm: {
                    title: 'Confirmar acción masiva',
                    submit: 'Sí, continuar',
                    body_approve: '¿Publicar {count} concepto(s)? Se omiten los que no tienen una marca confirmada o segura.',
                    body_reject: '¿Rechazar {count} concepto(s)?',
                    body_unlink: '¿Quitar el vínculo de marca de {count} concepto(s)?',
                    unlink_skipped: '{skipped} de la selección se omiten: no tienen marca vinculada.',
                    body_assign: '¿Vincular {count} concepto(s) a su marca encontrada? Los eventos aún deben aprobarse por separado.',
                    assign_skipped: '{skipped} de la selección se omiten: ya vinculados o sin coincidencia segura.',
                    and_more: 'y {count} más',
                    assign_managed: '{count} de estas marcas las gestiona activamente un Professional. Vincular puede chocar con su propio trabajo.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'detalles:',
            reported: 'reportado por:',
            suspended_at: 'suspendido en:',
            email: 'correo electrónico:',
            phonenumber: 'número de teléfono',
            message: 'mensaje:',
            singular: 'informe',
            plural: 'informes',
            reportables: {
                event: 'eventos',
                organization: 'organizaciones',
            },
            status: {
                submitted: 'Enviada',
                under_review: 'Bajo revisión',
                resolved: 'resuelta',
                no_issue: 'No hay problema',
            },
            reportables_by_type: {
                event: 'evento',
                organisation: 'organizaciones y marcas',
                user: "usuaria",
                created_by: 'creado por',
                report_by: 'informar por',
                ip_adress: 'apacigua',
                reason: 'razón',
                description: 'descripción',
                empty: 'vacía',
            },
            no_reports: 'No se encontraron informes',
        },
        lead: {
            singular: 'dirigir',
            plural: {
                event: 'líder del evento',
                organization: 'plomo de marca'
            }
        },
        block_user: {
            plural: 'Bloquear usuarias',

            title: 'obstruida',
            description: 'Su cuenta ha sido bloqueada, ya no tiene acceso a la plataforma.'
        },
        setting: {
            plural: 'ajustes',
            reset: {
                warning: {
                    title: 'Restablecer todas las configuraciones en el administrador.',
                    body: '¿Estás seguro de que quieres restablecer todas las configuraciones?'
                }
            }
        },
        permissions: {
            plural: 'permisos',
            levels: {
                'level-1': 'super administrador',
                'level-2': 'administración',
                'level-3': 'embajadora',
                'level-4': 'miembro premium',
                'level-5': 'miembro profesional',
                'level-6': 'miembro',
            },
            no_users_with_role: 'No hay usuarios con este nivel de roles.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'crear organización en nombre de otro usuario',
                'latinmap-verify': 'Grant estatus verificado de Map Latinmap',
                invite: {
                    'level-3': 'Invitar a embajadoras de la comunidad.',
                },
                reports: {
                    view: 'Ver informes',
                    delete: {
                        any: 'Eliminar cualquier informe',
                    },
                    update: 'Actualizar el estado del informe',
                    export: 'Informes de exportación',
                },
                events: {
                    create: 'crear eventos',
                    view: 'Ver eventos',
                    update: {
                        any: 'Actualizar cualquier evento',
                        own: 'Actualizar eventos propios',
                    },
                    delete: {
                        any: 'Eliminar cualquier evento',
                        own: 'Eliminar eventos propios',
                    },
                    publish: 'publicar eventos',
                    unpublish: 'eventos no publicados',
                    ownership: {
                        own: 'Cambiar la propiedad de los eventos propios',
                        any: 'cambiar la propiedad de cualquier evento',
                    },
                    ticketshop: {
                        enable: 'Habilitar TicketShop',
                    },
                },
                organisations: {
                    create: 'crear organizaciones y marcas',
                    update: {
                        any: 'Actualizar cualquier organización y marca',
                        own: 'Actualizar organizaciones y marcas propias',
                    },
                    delete: {
                        any: 'Eliminar cualquier organización y marca',
                        own: 'Eliminar propias organizaciones y marcas',
                    },
                    ownership: {
                        own: 'Cambiar la propiedad de propias organizaciones y marcas',
                        any: 'cambiar la propiedad de cualquier organización y marca',
                    },
                },
                users: {
                    edit: 'editar usuarios',
                },
                leads: {
                    view: 'Ver cables',
                    delete: 'eliminar los clientes potenciales',
                },
                transfer_requests: {
                    view: 'Ver solicitudes de transferencia',
                    approve: 'aprobar solicitudes de transferencia',
                }
            }
        },
        dance_styles: {
            title: 'estilos de baile',
            singular: 'estilo de baile',
            create: {
                singular: 'Crear estilo de baile',
            },
            edit: {
                singular: 'editar estilo de baile',
                plural: 'Editar estilos de baile',
            },
            delete: {
                title: '¿Eliminar el estilo de baile?',
                singular: 'borrar',
                cancel: 'Cancelar',
                confirmation: 'Este estilo de baile tiene estilos de baile subcons.',
                affected: 'Este estilo de baile se usa en {event_count} Events y {organization_count} organizaciones.',
                label: 'Eliminar estilo de baile',
                placeholder: 'Escriba "{keyword}" aquí y envíelo para eliminar este estilo de baile.',
            },
            sub_dance_style: 'Estilo de danza subyacente',
            is_favorite: 'es favorito',
        },
        music_styles: {
            title: 'estilos musicales',
            singular: 'estilo musical',
            create: {
                singular: 'Crear estilo musical',
            },
            edit: {
                singular: 'Editar estilo musical',
                plural: 'Editar estilos musicales',
            },
            delete: {
                title: '¿Eliminar estilo musical?',
                singular: 'borrar',
                cancel: 'Cancelar',
                confirmation: 'Este estilo musical tiene estilos de subs Music.',
                affected: 'Este estilo musical se usa en {event_count} Events y {organization_count} organizaciones.',
                label: 'Eliminar estilo musical',
                placeholder: 'Escriba "{keyword}" aquí y envíelo para eliminar este estilo de música.',
                substyles: 'Este estilo musical tiene estilos submusicos.',
            },
            sub_dance_style: 'Estilo de danza subyacente',
            sub_music_style: 'Estilo de subs Music',
            is_favorite: 'es favorito',
        },
        featuredEvent: 'evento destacado',
        event_types: {
            edit: {
                plural: 'editar tipos de eventos',
            }
        },
        brand_types: {
            edit: {
                plural: 'editar tipos de marca',
            }
        },
        prof_financial_title: 'centro financiero',
        modoration:
        {
            title: 'moderación',
        },
        official_brands: 'offical brands',
        export: {
            overview: {
                title: 'exportación y transferencias',
                subtitle: 'Exportar todas las organizaciones, se generará un enlace de transferencia para cada organización.'
            },
            create: 'Crear exportación',
            copied_link: 'enlace copiado',
            take_ownership: 'tomar posesión',
            validate_phone: 'Para tomar posesión de esta organización, primero debe validar su número de teléfono, esto se puede hacer a continuación aquí:',
            require_login: 'Para tomar posesión de esta organización, primero debe iniciar sesión o crear una cuenta, esto se puede hacer a continuación aquí:',
            to_login: 'Para iniciar sesión',
            messages: {
                opened: 'Su enlace de transferencia se ha activado con éxito, tiene 30 días para completar el proceso.',
                continue: 'Su enlace de transferencia se ha reabierto correctamente, finalice el proceso de transferencia.',
                no_key: 'No se ha proporcionado ninguna clave, esto puede suceder si actualizó la página, debe abrir el enlace original nuevamente.',
                not_exists: 'Actualmente no hay un enlace de transferencia para esta organización.',
                unauthorized: "No está autorizado para aceptar esta transferencia de organización.",
                expired: 'Este enlace ha expirado.',
                already_completed: 'Este enlace ya se ha completado y ya no se puede usar.',
                transferred: 'La organización ha sido transferida con éxito.'
            },
            warning: {
                title: 'Eliminar el enlace de transferencia',
                body: '¿Estás seguro de que quieres eliminar este enlace de transferencia?'
            },
            status: {
                no_action: 'no transferido',
                opened: 'abierta',
                completed: 'transferida',
                expired: 'Caducada'
            }
        },
        duplications: 'duplicaciones',
        suspend_toggle: {
            warning: {
                title: 'suspensión de alternar',
                body: '¿Estás seguro de que quieres cambiar la suspensión de esto?'
            }
        },
        take_offline: {
            warning: {
                title: 'desconectar',
                body: '¿Estás seguro de que quieres estar fuera de línea? Ya no será visible para los usuarios.'
            }
        },
        bring_online: {
            warning: {
                title: 'Poner en línea',
                body: '¿Estás seguro de que quieres poner esto en línea? Será visible para los usuarios.'
            }
        },
        'carousel-image': {
            plural: "Imágenes del carrusel",
            overview: {
                title: "Imágenes del carrusel",
                subtitle: "Gestiona las imágenes del carrusel en la página principal."
            },
            create: {
                singular: "Crear imagen del carrusel",
                success: "Imagen del carrusel creada con éxito",
                error: "Error al crear la imagen del carrusel"
            },
            delete: {
                success: "Imagen del carrusel eliminada con éxito",
                error: "Error al eliminar la imagen del carrusel"
            },
            image: "Imagen",
            visibility: 'segundos visibles',
            title: "Título",
            order_by: "Ordenar por",
            warning: {
                body: "¿Estás seguro de que deseas eliminar esta imagen del carrusel? Esta acción no se puede deshacer.",
                title: "Eliminar imagen del carrusel"
            },
        },
        'beta-feature': {
            plural: 'Características beta',
            overview: {
                title: 'Características beta',
                subtitle: 'Gestionar las características beta de la plataforma.',
                success: 'Características beta actualizadas con éxito',
                error: 'Error al actualizar las características beta',
            },
            key: 'Clave',
            name: 'Nombre',
            description: 'Descripción',
            visible_to_admins: 'Visible para administradores',
            visible_to_users: 'Visible para usuarios',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Agenda Latin',
            options: {
                all_events: 'todos los eventos',
                latin_festivals_and_congresses: 'Festivales y congresos latinos',
                latin_parties_and_socials: 'fiestas latinas y sociales'
            }
        },
        dance_schools: {
            label: 'Escuelas de Baile Latin',
            options: {
                dance_schools: 'Escuelas de Baile',
                try_outs_and_start_courses: 'Pruebe los Cursos y Comience los cursos',
                workshops_and_bootcamps: 'Talleres y Bootcamps',
                about_the_latin_dance_scene: 'Sobre la Escena de Baile Latin'
            }
        },
        community: {
            label: 'Comunidad Latin',
            options: {
                teachers: 'Maestras',
                show_performers_and_teams: 'Mostrar Artistas y Equipos',
                djs: 'DJ',
                live_bands: 'Bandas en Vivo',
                media_photo_video: 'Medios, Foto, Video',
                mcs: 'MC'
            }
        },
        dancewear_and_shoes: {
            label: 'Ropa de Baile Latin y Zapatos',
            options: {
                dancewear_and_shoes: 'Ropa de Baile y Zapatos'
            }
        },
        for_professionals: {
            label: 'Para Profesionales',
            options: {
                create_a_brand: 'Cómo Crear una Marca',
                create_an_event: 'Cómo Crear un Evento',
                promote_your_event: 'Cómo Promocionar tu Evento',
                professional_account_verification: 'Verificación de Cuenta Profesional'
            }
        },
        join: {
            label: 'Únete a LatinMap',
            options: {
                create_a_brand_or_organization: 'Crear una Marca u Organización',
                become_an_ambassador: 'Convertirse en Embajador'
            }
        },
        manage_and_promote: {
            label: 'Gestionar y Promover',
            options: {
                my_events: 'Mis Eventos',
                promote_your_event: 'Promociona tu Evento'
            }
        }
    },
    impersonation: {
        banner: 'Estás viendo como {name}',
        stop: 'Dejar de suplantar',
    },
    menu_headers: {
        general_title: 'general',
        orders_title: 'Mis pedidos',
        settings_title: 'ajustes',
        professional_title: 'profesional',
        prof_financial_title: 'Mi centro financiero',
        special_access_title: 'acceso especial',
        community_dashboard_title: 'Mi embajador del tablero de la comunidad',
        session_title: 'sesión',
    },
    account: {
        organization_settings_title: 'Configuración de la Organización',
        selected_organization: 'Organización seleccionada',
        my_events: 'mis eventos',
        role: 'Role',
        dashboard: "panel",
        default_filters: "Mis búsquedas",
        login: "acceso",
        logout: "cierre de sesión",
        sign_in: "iniciar sesión",
        sign_up: "inscribirse",
        email_address: "dirección de correo electrónico",
        password: "contraseña",
        password_repeat: "Repita la contraseña",
        password_reset: "Restablecer la contraseña",
        password_forgot: "Contraseña olvidada",
        reset_password: "restablecer contraseña",
        current_password: "Contraseña actual",
        change_password: "cambiar la contraseña",
        new_password: "Nueva contraseña",
        password_reset_success: "Restablecimiento de contraseña exitosa",
        forgot_password: "Has olvidado tu contraseña",
        not_a_member: "No es miembro",
        i_already_have_an_account: "Ya tengo una cuenta",
        i_accept_the: "Acepto el",
        terms_and_conditions: "Términos y condiciones",
        first_name: "nombre de pila",
        last_name: "apellido",
        postal_code: "Código Postal",
        street_number: "número de calle",
        city: "ciudad",
        country: "país",
        preferred_language: "Idioma preferido",
        date_of_birth: "fecha de nacimiento",
        create: "crear una cuenta",
        my_account: "mi cuenta",
        my_professional_dashboard: "Mi tablero profesional",
        ambassador_dashboard: "tablero de embajadores",
        my_organisations: "mis organizaciones y marcas",
        my_organisations_description: "Administre sus organizaciones y marcas",
        singular: "cuenta",
        phone: "número de teléfono",
        phone_verification_token: "Token de verificación telefónico",
        name: "nombre",
        user_name: "nombre de usuario",
        resend_verification: "reiniciar la verificación",
        update_error: 'La actualización de su cuenta falló.',
        myLatinmap: "Mi LatinMap",
        dancerprofile: "Mi perfil de bailarín",
        orders: 'Mis pedidos',
        phone_verification: 'verificación telefónica',
        submitted_leads: 'mis clientes potenciales presentados',
        settings: 'ajustes',
        switch: 'Cambiar a marca/organización',
        beta_features: 'Características beta',
        gender: {
            singular: "género",
            male: "masculina",
            female: "femenina",
            other: "otra",
        },
        profile: {
            title: 'perfil',
            description: 'Administre la información de su perfil, cambie su contraseña y más.',
        },
        remove: {
            label: 'eliminar cuenta',
            placeholder: 'Type "delete" here and submit to remove your account.',
            admin_placeholder: 'Type "delete" here and submit to remove this account.',
            safeword: 'borrar',
            description: 'Esto eliminará su cuenta y todos los datos asociados.',
        },
        favorites: {
            title: 'favoritas',
            description: 'Tus eventos favoritos, escuelas de baile, etc.',
            no_favorites: 'Aún no tienes favoritas en esta categoría.',
            plurals: {
                event: 'eventos',
                dancer: 'bailarinas',
                dj: 'DJ',
                media: 'medios de comunicación',
                brand: 'zapatos de baile, ropa, tienda',
                school: 'escuelas de baile',
                venue: 'Lugares',
                club: "club",
                teacher: "maestra",
                show_performers_and_teams: "Mostrar artistas y equipos",
                performer: "ejecutante",
                mc: "mc",
                latin_music: "música latina",
                event_organizer: "Organizadora de eventos",
                organization: 'organizaciones y marcas',
            },
        },
        likes: {
            title: 'gustos',
            description: 'Tus eventos gustos, escuelas de baile, etc.',
            no_likes: 'todavía no tienes me gusta en esta categoría',
            plurals: {
                event: 'eventos',
                dancer: 'bailarinas',
                dj: 'DJ',
                media: 'Medios (foto, video, edición de video)',
                brand: 'zapatos de baile, ropa, tienda',
                school: 'escuelas de baile',
                venue: 'Lugares',
                club: "club",
                teacher: "maestra",
                show_performers_and_teams: "Mostrar artistas y equipos",
                performer: "ejecutante",
                mc: "mc",
                latin_music: "música latina",
                event_organizer: "Organizadora de eventos",
                organization: 'organizaciones y marcas',
            },
        },
        verification: {
            phone: {
                description: "Se necesita verificación del teléfono para garantizar la seguridad y la autenticidad de los usuarios que acceden al tablero \'profesional\'.",
                not_verified: 'Su número de teléfono no está verificado.',
                send_verification_text: 'Enviar texto de verificación',
                sent: 'texto de verificación enviado',
                verified: 'Su número de teléfono está verificado.',
                verify: 'Verificar el número de teléfono',
            },
        },

    },
    dashboard: {
        title: "panel",
        welcome: "bienvenida",
    },
    organizations: {
        organization_saved: 'organización guardada',
        containing_emoji_error: 'No se permiten emojis en el nombre. Use caracteres alfanuméricos o caracteres especiales permitidos.',
        invalid_character_error: 'Hay un carácter no válido en el nombre. Utilice caracteres alfanuméricos o caracteres especiales permitidos.\nCaracteres no válidos: ',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'toda',
                    },
                    organization_type: {
                        all: 'toda',
                        dance_schools: 'escuelas de baile',
                        organizers: 'organizadoras',
                        artists: 'Profesores y artistas',
                        disk_jockeys: 'DJ',
                    }
                }
            },
            no_results: {
                title: 'No hay organizaciones encontradas',
                subtitle: 'No se encontraron organizaciones para los filtros seleccionados.'
            },
        },
        transfers: {
            overview: {
                title: 'transferencias',
                subtitle: 'Administrar la propiedad de sus organizaciones',
                incoming_transfers: 'transferencias entrantes',
                outgoing_transfers: 'transferencias salientes',
                request: 'pedido',
                offer: 'oferta',
                event: 'evento',
                organization: 'organización',
            },
            status: {
                approved: 'transferencia aceptada',
                pending: 'pendiente',
                rejected: 'Transfer Declined'
            },
            create: {
                title: 'propietario de transferencia',
                organization: 'organización',
                description: 'Transfiera la propiedad de su organización a otro usuario.',
                reason: 'razón',
                transfer_to: 'Transferir a (correo electrónico)',
                transfer: 'transferir',
                warning: 'Tan pronto como se acepte la transferencia, la propiedad de la organización será transferida al nuevo propietario.',
            }
        },
        remove: {
            label: 'Eliminar Organización',
            description: 'Eliminar permanentemente esta organización y todos los datos asociados.',
            success: 'Organización eliminada exitosamente',
            error: 'No se pudo eliminar la organización'
        },
        transactions: {
            overview: {
                title: 'actas',
                subtitle: 'Administrar las transacciones de sus organizaciones y marcas',
            }
        },
        create: 'Crear organización',
        is_public_options: {
            private: 'privada',
            public: 'pública',
            private_warning: 'Su organización no es visible en línea con este estado.'
        },
        offline_preview: 'Esta organización está fuera de línea y solo es visible como vista previa.',
    },
    organization: {
        accepts_posts_on_behalf: 'Permitir que LatinMap añada nuestros eventos',
        accepts_posts_on_behalf_help: 'Cuando nuestra marca está inactiva, LatinMap puede añadir eventos anunciados públicamente en nuestro nombre. Están claramente marcados y puedes editarlos o eliminarlos cuando quieras.',
        'on-behalf-of': 'a nombre de',
        'on-behalf': {
            none: 'Seleccione su opción',
            me: 'yo, represento a esta marca',
            other: 'Como representante de la marca',
            noone: 'Como embajadora de LatinMap',
        },
        featured: {
            title: 'Escuelas de danza destacadas',
            subtitle: 'Algunas de las academias de danza destacadas con clases con cursos de baile ahora disponibles.',
        },
        my_favorites: {
            title: 'Mis favoritas',
        },
        edit: {
            public_information: 'información',
            customers: 'Clientas',
            events: 'eventos',
            tickets: 'entradas',
            authorized_person: 'gente autorizada',
        },
        organization_detail: {
            involved: 'involucrada',
            verification_status: {
                verified: 'verificada',
                not_verified: 'aún no verificado',
            }
        },
        account: {
            title: "cuenta",
            description: "Administre la información de su cuenta para el tablero profesional.",
            description_not_verified: "Verifique el número de teléfono para usar el tablero profesional.",
        },
        transfer: {
            title: 'propietario de transferencia',
            description: '¿Desea solicitar la propiedad de esta organización?',
            what: '¿Qué se ofrece?',
            submit: 'Solicitud de envío',
            name: 'nombre',
            location: 'ubicación',
            email: 'correo electrónico',
            reason: 'razón',
            organization: 'organización y marca',
            errors: {
                nameRequired: 'se requiere el nombre.',
                emailRequired: 'Se requiere correo electrónico.',
                reasonRequired: 'se requiere razón.'
            },
            succesfully_sent: 'La solicitud de transferencia se ha enviado correctamente.',
            error_occurred: 'Algo salió mal.',
            noOrganisation: 'Todavía no tiene organizaciones.'
        },
        title: "organización",
        is_public: 'Es pública',
        publicly_visible: 'visible públicamente',
        change_organization: "organización de cambio",
        create: "Crear organización",
        name: "nombre",
        name_without_dj: "Nombre (sin 'dj')",
        dj_name_tooltip: "Ingrese solo el nombre. 'DJ' se agregará automáticamente.",
        email: "correo electrónico",
        phone: "número de teléfono",
        phone_verification_token: "Token de verificación telefónico",
        country: "país",
        city: "ciudad",
        street: "calle",
        street_number: "número de calle",
        postal_code: "Código Postal",
        type: "tipo",
        question: "tu organización?",
        types: {
            event: 'Evento',
            dancer: "bailarina",
            latin_music: "música latina",
            performer: "ejecutante",
            teacher: "maestra",
            show_performers_and_teams: "Mostrar artistas y equipos",
            dj: "DJ",
            mc: "mc",
            media: "Medios (foto, video, edición de video)",
            brand: "zapatos de baile, ropa, tienda",
            event_organizer: "Organizadora de eventos",
            school: "escuela de baile",
            live_music: "banda/música en vivo",
            venue: "evento",
        },
        short_description: "descripción corta",
        long_description: "descripción larga",
        photos: "fotos",
        dance_styles: "estilos de baile",
        music_styles: "estilos musicales",
        my_brands: "mis marcas",
        my_brands_description: "Administra tus marcas",
        overview: {
            title: 'escuelas de baile',
            subtitle: 'Encuentra las mejores escuelas de baile en tu área.',
            filters: {
                organization_name: 'nombre de la organización',
                dance_styles: 'estilos de baile',
                postal_code: 'Código Postal',
                nearby_range: 'rango de sugerencias de código postal cercano',
                nearby: 'sugerencias cercanas',
                location: 'dónde',
                favorites: 'favoritas',
                country_codes: 'códigos de país',
                music_styles: 'estilos musicales',
                ambassadors: 'embajadora',
                slidertooltip: '<p><strong> El control deslizante de rango ajusta los dígitos del código postal ingresado para expandir el área de búsqueda. </strong><p> Cada paso aumenta el código postal en 100. </p><p> Por ejemplo, a',
            },
            organizers: {
                title: 'organizadoras',
                subtitle: 'Encuentra los mejores organizadores de tu área.',
            },
            artists: {
                title: 'Profesores y artistas',
                subtitle: 'Encuentra los mejores artistas de tu área.',
            },
            dance_schools: {
                title: 'escuelas de baile',
                subtitle: 'Encuentra las mejores escuelas de baile en tu área.',
            },
            disk_jockeys: {
                title: 'DJ',
                subtitle: 'Encuentra a los mejores DJs de tu zona. Disfruta de los mejores eventos y festivales.',
            },
            show_performers_and_teams: {
                title: 'Mostrar artistas y equipos',
                subtitle: 'Encuentra los mejores artistas de tu área.',
            },
            teacher: {
                title: 'maestras',
                subtitle: 'Encuentra los mejores maestros de tu área.',
            },
            mcs: {
                title: "MC",
                subtitle: 'Encuentra los mejores MC en tu área.',
            },
            live_music: {
                title: "bandas/música en vivo",
                subtitle: 'Encuentra las mejores bandas y música en vivo de tu área.',
            },
            live_performer: {
                title: "intérprete en vivo",
                subtitle: 'Encuentra los mejores artistas en vivo de tu área.',
            },
            performer: {
                title: "ejecutante",
                subtitle:
                    "Encuentra los mejores artistas en vivo de tu zona. Disfruta de los mejores eventos y festivales."
            },
            media: {
                title: "Medios (foto, video, edición de video)",
                subtitle: 'Encuentra los mejores fotógrafos y camarógrafos en tu área.',
            },
            brand: {
                title: "zapatos de baile, ropa, tienda",
                subtitle: 'Encuentra los mejores zapatos de baile y ropa de tu área.',
            },
        },
        artists: {
            title: 'Profesores y artistas',
        },
        teacher: {
            title: 'maestras',
        },
        performer: {
            title: 'artista'
        },
        show_performers_and_teams: {
            title: 'Mostrar artistas y equipos',
        },
        dance_schools: {
            title: 'escuelas de baile',
        },
        disk_jockeys: {
            title: 'DJ',
        },
        organizers: {
            title: 'organizadoras',
        },
        manage_authorized_people: {
            title: 'Gestionar personas autorizadas',
            description: 'Administra a las personas autorizadas de las organizaciones de las que eres propietario. Las personas autorizadas pueden gestionar tu organización y tus eventos.'
        },
        authorized_people: {
            title: 'Personas autorizadas',
            description: 'Gestionar las personas autorizadas de sus organizaciones. Las personas autorizadas pueden gestionar su organización y eventos.',
            create: 'Crear persona autorizada',
            edit: 'Editar persona autorizada',
            overview: 'Personas autorizadas',
            not_found: 'No se encontraron personas autorizadas',
        },
        mcs: {
            title: "MC",
        },
        live_music: {
            title: "bandas/música en vivo",
        },
        live_performer: {
            title: "artistas en vivo",
        },
        media: {
            title: "Medios (foto, video, edición de video)",
        },
        brand: {
            title: "zapatos de baile, ropa, tienda",
        },
        email_authorized: 'Ingrese una dirección de correo electrónico existente.',
    },
    ambassador: {
        profile: "perfil",
        my_brands: "mis marcas",
        verification: {
            phone: {
                description: "Se necesita verificación del teléfono para garantizar la seguridad y la autenticidad de los usuarios que acceden al tablero de \'Embajador\'."
            }
        }
    },
    brands: {
        create: "crear marca",
        brand_saved: "marca guardada",
        change_brand: "cambiar la marca",
        edit: {
            authorized_person: "gente autorizada"
        },
        posted_by_ambassador_text: 'Esta marca fue creada por un embajador de LatinMap, un miembro de la comunidad de confianza que contribuye al contenido de la plataforma.',
    },
    contact: {
        title: "contacto",
        name: "nombre",
        email: "correo electrónico",
        message: "mensaje",
        subject: "Sujeta",
        send: "enviar",
        success: "mensaje enviado",
        error: "El mensaje no se pudo enviar",
    },
    ticketstore: {
        select_amount: 'Seleccionar el monto del boleto',
        your_information: 'Tu información',
        total: 'total',
        next: 'próxima',
        back: 'atrás',
        checkout: 'verificar',
        tickets_for: 'entradas para',
        ticket_types: 'tipos de boletos',
        ticket: {
            starts_at: 'comienza en',
            location: 'ubicación',
            name: 'nombre',
            description: 'descripción',
            tickets_sold: 'boletos vendidos',
            actions: 'comportamiento',
            available: 'disponible',
            total_available: 'Total disponible',
            price: 'precio',
            create: 'Crear tipo de boleto',
            edit: 'Editar Tipo de boleto',
            success: 'Su tipo de boleto ha sido enviado correctamente.',
            remove_label: 'Eliminar el tipo de boleto',
            remove_description: 'Esto eliminará el tipo de ticket y todos los datos asociados.',
        },
    },
    events: {
        owned_by_organization: 'Propiedad de la organización {organization_name}',
        select_category: "Seleccione una categoría",
        select_country: "Seleccione un país",
        select_timezone: "Seleccione una zona horaria",
        select_status: "Seleccione un estado",
        select_currency: "Seleccione una moneda",
        select_brand_error: "No se ha seleccionado ninguna marca",
        title: 'eventos',
        bring_online: 'Poner en línea',
        take_offline: 'Desconectarse',
        by: 'Eventos de {organization_name}',
        create_new: 'Crea un nuevo evento',
        event_saved: 'Evento guardado',
        event_published: 'Su evento ahora es en vivo y visible en la página de eventos.',
        error_saving: 'Evento de ahorro de errores',
        containing_emoji_error: 'No se permiten emojis en el nombre. Use caracteres alfanuméricos o caracteres especiales permitidos.',
        invalid_character_error: 'Hay un carácter no válido en el nombre. Utilice caracteres alfanuméricos o caracteres especiales permitidos.\nCaracteres no válidos: ',
        duration_too_long: 'La duración de este evento es demasiado larga, la cantidad máxima de días que un evento puede tomar es: ',
        error_updating_ticket_type: 'Se produjo un error al guardar el tipo de boleto.',
        ticket_type_updated: 'El tipo de boleto se ha actualizado con éxito.',
        posted_by_ambassador: 'Publicado por latinmap embajadora',
        posted_by_ambassador_text: 'Este evento fue creado por un embajador de LatinMap, un miembro de la comunidad de confianza que contribuye al contenido de la plataforma.',
        posted_on_behalf_text: 'LatinMap añadió este evento a partir de información disponible públicamente. El organizador aún no ha actualizado esta información del evento.',
        posted_on_behalf_label: 'añadido por LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Publicado por LatinMap',
        not_posted_by_ambassador: 'Verificada por la organizadora',
        participants: {
            create: {
                title: 'Create participant for "{event_name}"',
                description: 'Create a new participant for the event "{event_name}"',
                invite: 'Invitar participante',
                role: 'role',
            },
            role: {
                performer: 'ejecutante',
                organizer: 'organizadora',
            },
            overview: {
                participants: 'Las participantes',
            }
        },
        statuses: {
            active: 'activa',
            canceled: 'cancelada',
            changed: 'cambió',
            pending: 'pendiente'
        },
        currencies: {
            none: 'Sin moneda',
            euro: 'Euro',
            dollar_american: 'Dólar Americano',
            pound_uk: 'Libra Inglesa',
            lira_turkish: 'Lira Turca',
            rupee_indian: 'Rupia India'
        },
        event_detail: {
            cta_block: {
                title: 'entradas',
                subtitle: '¡Hay entradas disponibles para este evento!',
                button: 'Obtenga sus boletos ahora'
            },
            organizer: {
                plural: 'organizadoras',
                singular: 'organizadora',
                invariable: 'organizador (s)',
            }
        },
        overview: {
            title: 'eventos',
            nearby_events: 'eventos cercanos',
            subtitle: 'Sumérgete en los ritmos rítmicos, movimientos estimulantes y fusión cultural de salsa, bachata y más.',
            festival: {
                title: 'Festivales de danza y congresos',
            },
            try_out: {
                title: 'Pruebas, jornada de puertas abiertas, inicio de curso(s)',
            },
            party_social: {
                title: 'Fiestas y Sociales',
            },
            no_results: {
                title: 'No se encuentran eventos',
                subtitle: 'No se encuentran eventos para los filtros seleccionados.'
            },
            filters: {
                event_name: 'Nombre del evento u organización',
                event_id: 'ID del evento',
                event_category: 'tipo de evento',
                dance_styles: 'estilos de baile',
                dance_style: 'estilo de baile',
                music_styles: 'estilos musicales',
                music_style: 'estilo musical',
                ambassadors: 'embajadora',
                status: 'estado',
                user_name: 'usuaria',
                user_type: 'tipo de usuario',
                organization: 'organización',
                organization_type: 'Tipo de organización',
                location: 'dónde',
                date: 'cuando',
                date_from: 'de',
                date_to: 'a',
                apply_filters: 'Aplicar filtros',
                clear_filters: 'Filtros claros',
                country_codes: 'códigos de país',
                city: 'ciudad',
                favorites: 'favoritas',
                postal_code: 'Código Postal',
                nearby_range: 'rango de sugerencias de código postal cercano',
                apply: 'aplicar',
                sliderinfo: 'incrementos de 100',
                slidertooltip: '<p><strong> El control deslizante de rango ajusta los dígitos del código postal ingresado para expandir el área de búsqueda. </strong><p> Cada paso aumenta el código postal en 100. </p> <p> Por ejemplo, a',
                option_labels: {
                    date_filter: {
                        upcoming: 'próxima',
                        this_week: 'esta semana',
                        next_week: 'la próxima semana',
                        in_two_weeks: 'En dos semanas +',
                        this_month: 'este mes',
                        specific_dates: 'fechas específicas',
                        all: 'toda'
                    },
                    favorites: {
                        all: 'toda',
                        favorites: 'favoritas',
                        likes: 'Mostrar solo mis eventos gustos',
                        favorites_likes: 'Mostrar eventos o eventos de marcas favoritas',
                    },
                    organization_type: {
                        all: 'toda',
                        dance_schools: 'escuelas de baile',
                        organizers: 'organizadoras',
                        music_styles: 'estilos musicales',
                        music_style: 'estilo musical',
                        artists: 'Profesores y artistas',
                        disk_jockeys: 'DJ',
                    },
                    user_type: {
                        professional: 'profesional',
                        ambassador: 'embajadora',
                        admin: 'administración',
                        superadmin: 'superadmin'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'talleres y bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'festivales y congresos',
            try_out: 'try-outs, jornada de puertas abiertas, inicio de curso(s)',
            live_music: 'bandas/música en vivo',
            workshop_bootcamp: 'talleres y bootcamps',
        },
        categories: {
            festival: 'Festival/Congreso',
            workshop_bootcamp: 'Taller/Bootcamp',
            workshop_bootcamp_party: 'fiesta con taller/bootcamp',
            party_social: 'fiesta/social',
            competition: 'competencia',
            performance_concert: 'actuación/concierto',
            outdoor_event: 'evento al aire libre',
            dance_trip: 'viaje de baile',
            party_live_music: 'fiesta/música en vivo',
            online_event: 'evento en línea',
            try_out: 'Pruebas, jornada de puertas abiertas, inicio de curso(s)',
            show: 'espectáculo',
            marathon: 'maratón',
            weekender: 'semanario',
            retreat: 'Retiro',
            other: 'otra',
        },
        create: 'Crear evento',
        edit: 'Evento de edición',
        remove: {
            label: 'Eliminar evento',
            description: 'Esto eliminará el evento y todos los datos asociados.',
        },
        brand: 'marca/organización',
        name: 'nombre',
        country: 'país',
        city: 'ciudad',
        street: 'calle',
        street_number: 'número de calle',
        short_description: 'descripción corta',
        long_description: 'descripción larga',
        dance_styles: 'estilos de baile',
        music_styles: 'estilos musicales',
        photos: 'fotos',
        photos_preview_mode: 'Las fotos son visibles después de guardar en modo de vista previa',
        preview: 'espectáculo',
        category: 'tipo de evento',
        language: 'idioma',
        location_type: {
            singular: 'Tipo de ubicación',
            online: 'virtual',
            offline: 'en persona',
        },
        timezone: 'zona horaria',
        date: 'fecha',
        week: 'semana',
        start: 'comenzar',
        end: 'fin',
        location: 'ubicación',
        information: 'información',
        start_date: 'fecha de inicio',
        start_time: 'hora de inicio',
        end_date: 'fecha final',
        end_time: 'tiempo de finalización',
        ends_at: 'fines',
        registration_opens_at: 'El registro se abre en',
        registration_closes_at: 'El registro se cierra en',
        is_public: '¿Listo para ir en vivo?',
        location_name: 'nombre del lugar',
        photos_required: 'Se requiere al menos una foto.',
        tickets_sold: 'boletos vendidos',
        actions: 'comportamiento',
        participate: 'participar',
        verified: 'Brand Oficial Verificado',
        undercondition: 'aún no confirmado',
        warning: 'Cambio importante - Última actualización:',
        ticket:'Tickets available',
        cancelled: 'cancelado - Última actualización:',
        upcoming: 'próximos eventos',
        past: 'eventos pasados',
        status: 'estado',
        status_reason: 'estatus',
        entrance: 'Precios de las entradas',
        entrance_tooltip: 'Aquí puede especificar el precio de la entrada. Introduzca un número si el precio no cambia, por ejemplo: \'5\'. Para un rango de precios, puede especificarlo, por ejemplo, \'5-10\'. Utilice \'free\' si no hay precio de entrada.',
        currency: 'divisa',
        currency_tooltip: 'También es posible especificar la moneda. Las monedas más utilizadas son: euro (€), dólar estadounidense ($), libra esterlina (£), lira turca (₺) y rupia india (₹). Si no se selecciona ninguna moneda, puede agregar cualquier texto, como "5-12 euros".',
        repeat: 'repeticiones',
        djs: 'DJ',
        dj: 'DJ',
        artists: 'artistas',
        artist: 'artista',
        question: "tu evento?",
        status_options: {
            active: 'activa',
            canceled: 'cancelada',
            pending: 'todavía no confirmado',
            changed: 'cambio importante',
        },
        is_public_options: {
            draft: 'borrador',
            private: 'privada',
            public: 'pública',
            draft_message: 'Guarde su evento como borrador.',
            private_message: 'Su evento será visible solo para los usuarios con acceso.',
            public_message: 'Publique su evento para hacerlo visible en la página de eventos.',
            private_warning: 'Su evento no es visible en línea con este estado.'
        },
        legend: {
            title: 'leyenda',
            verified: 'Brand Oficial Verificado',
            not_verified: 'No verificado por la organización: el organizador aún no ha confirmado la actividad.',
            cancelled: 'cancelada',
            warning: 'cambio importante',
            posted_by: 'Publicado por latinmap embajadora',
            condition: 'todavía no confirmado',
            ticket:'Tickets available',
            duplicate_event_error: 'Un evento con este nombre, fecha de inicio y fecha de finalización ya existe',
            ticket_order: 'Entradas disponibles, ¡cómpralas aquí!'
        },
        ticket_types: 'tipos de boletos',
        potential_duplicates: 'posibles duplicados',
        proceed_anyway: 'Ahorre a pesar de duplicado',
        duplicate_event_error: 'Un evento con este nombre, fecha de inicio y fecha de finalización ya existe',
        event_deleted: 'Evento eliminado',
        error_deleting_event: 'Evento de eliminación de errores',
        featured: {
            title: 'Eventos destacados en la comunidad',
            subtitle: '¡Descubra y obtenga sus entradas para festivales de baile, conciertos y viajes al mejor precio!',
            badge: 'Destacado',
            view: 'Ver evento',
            title_page: 'Cambiar el precio global',
            featured_event: "comprar evento destacado",
            duration_type: "tipo de duración",
            day: "día",
            month: "mes",
            year: "año",
            duration: "duración",
            price: "precio",
            calculate_price: "calcular el precio",
            proceed_to_payment: "proceder al pago",
            current_price: "precio actual",
            no_price_found: "no se encuentra el precio para la duración seleccionada",
            update_price: "precio de actualización",
            setFeaturedEvents: "Establecer evento destacado",
            fetch_current_price: "Obtener precio actual",
            update_global_event_price: "Actualizar el precio del evento global",
            price_per_day: 'precio por día',
            buy: 'comprar evento destacado',
            duration_label: '¿Por cuánto tiempo le gustaría presentar el evento?',
            enter_duration: 'seleccionar duración',
            total_price: 'total',
            yes: "Sí",
            no: "No",
            invalid_invoice: 'Algo salió mal, intenta de nuevo',
            download_failed: 'Algo salió mal, intenta de nuevo',
            setFeaturedEvent: 'Establecer evento destacado para:',
            setFeatured: 'Establecer evento destacado',
            featured_success: 'El evento ha sido presentado con éxito.',
            already_featured: 'Este evento ya está aparecido',
            featured_error: 'Algo salió mal',
            durationError: 'el valor no puede ser inferior a 1'
        },
    },
    blocked_user:{
        create: 'Create blocked user',
        edit: 'Actualizar usuario bloqueada',

        blocked_email: 'correo electrónico bloqueado',
        blocked_phone_number: 'Blocked phone number',
        reason: 'Reason',

        delete: {
            warning: {
                title: 'Eliminar el bloqueo de usuarios',
                body: '¿Estás seguro de que quieres eliminar este bloque?'
            }
        }
    },
    carousel: {
        title: '¡Descubra el baile latino - eventos, escuelas, pruebas y más cerca de usted!',
        subtitle: 'Encuentre dónde bailar, aprender y conectarse con la comunidad latina.',
        search: {
            placeholder: 'Ingresa una palabra clave o ciudad para explorar las opciones de baile latino...',
            button: 'DESCUBRIR',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'En directo desde la pista',
            subtitle: 'Lo último de nuestro Instagram: la escena tal y como es, semana a semana.',
            follow: 'Sigue a {handle}',
            post_alt: 'Una publicación de {handle} en Instagram',
        },
        cta_block_1: {
            title: '¿Organizas eventos de baile?',
            subtitle:
                'Si organizas fiestas, festivales, salidas, congresos, fines de semana, talleres, cursos intensivos y conciertos de baile, tenemos algo para ti. ¡Promociona tu evento, gestiona promotores y vende entradas!',
            button: 'Regístrate ahora'
        },
        cta_block_2: {
            title: 'Descubre Eventos Cerca de Ti',
            subtitle:
                'Descubre eventos y actividades en tu área. ¡Explora y disfruta de las experiencias!',
            placeholder: 'Tu ubicación',
            input_button: 'Cerca de mí',
            button: 'Encontrar eventos'
        },
        cta_block_3: {
            button: 'Crear Evento',
        },
        choose_and_live_experiences: 'Elige y vive experiencias',
        experiences: {
            festivals_congresses: "Festivales y Congresos",
            parties_socials: "Fiestas y Sociales",
            try_outs_start_courses: "Clases de prueba y Cursos de iniciación",
            dance_schools: "Escuelas de baile",
            workshops_bootcamps: "Talleres y Bootcamps",
            dancewear_shoes: "Ropa y Zapatos de baile",
            teachers: "Profesores",
            show_performers_teams: "Artistas y Equipos de show",
            djs: 'DJ\'s',
            live_music: "Bandas en vivo",
            media_photo_video: "Medios (Foto/Video)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Comienza tu viaje en LatinMap',
            subtitle: 'Elige cómo quieres experimentar LatinMap',
            agenda: {
                title: 'Agenda Mundial',
                sub_header: 'Acceso libre',
                subtitle: 'Explora la escena global de baile latino',
                description: 'Descubre fiestas, talleres, festivales, clases de prueba y cursos de inicio - todo en una agenda',
                button: 'Ver Latin Agenda',
                footer: 'No se requiere cuenta'
            },
            member: {
                title: 'Hazte Miembro',
                sub_header: 'Cuenta gratuita',
                subtitle: 'Construye tu propia experiencia LatinMap',
                description: 'Crea tu LatinMap personal y mantente conectado con la escena de baile latino — local e internacionalmente.',
                features: {
                    agenda: 'Agenda completa y actualizada de baile latino',
                    follow: 'Sigue tus eventos, artistas y marcas favoritos',
                    save: 'Guarda tus favoritos con un clic',
                    store: 'Almacena tus búsquedas y descubrimientos',
                    custom_agenda: 'Crea tu propia agenda personalizada',
                    explore: 'Explora nuevas ciudades, estilos y escenas'
                },
                button: 'Crear cuenta gratis',
                footer: 'Gratis para unirse – nunca te pierdas un evento'
            },
            professional: {
                title: 'Hazte Profesional',
                sub_header: 'Perfil profesional gratuito',
                subtitle: 'Para festivales, escuelas de baile, profesores, DJs, músicos y organizadores',
                description: 'Aumenta tu visibilidad, gestiona tus eventos y alcanza la comunidad latina internacional.',
                features: {
                    brand_page: 'Tu propia página de marca profesional',
                    publish: 'Publica y gestiona eventos fácilmente',
                    invite: 'Invita a miembros del equipo a colaborar',
                    insights: 'Estadísticas y herramientas de crecimiento',
                    exposure: 'Exposición internacional en LatinMap'
                },
                button: 'Activar cuenta Pro',
                footer: 'Requiere primero una cuenta de Miembro'
            }
        },
    },
    dropzone: {
        drop_here: 'Deje caer archivos aquí para cargar',
        files_required: "{Count} requerido",
        max_filesize: "Tamaño máximo del archivo: {max} MB"
    },
    general: {
        select_organization_please: "Por favor, seleccione una organización",
        no_organization_selected: "No se ha seleccionado ninguna organización",
        all: 'toda',
        styles: 'estilos',
        important_information: 'información importante',
        starts_at: 'de',
        ends_at: 'a',
        socialmedia_links: 'campo de golf',
        share_with_your_friends: 'Comparte con tus amigos',
        link_copied: '¡Enlace copiado al portapapeles!',
        link_copy_failed: 'Error al copiar el enlace.',
        hosted_by: 'organizado por',
        created_by: 'creado por',
        posted_by: 'Publicado por',
        created: 'creada',
        archive: 'archivo',
        modified: 'modificada',
        score: 'puntaje',
        reset: 'reiniciar',
        unknown: 'desconocida',
        submit: 'entregar',
        suggest: 'sugerir',
        other: 'otra',
        delete: 'borrar',
        copy_link: 'enlace de copia',
        back: 'atrás',
        show: 'espectáculo',
        duplicate: 'duplicada',
        proceed: 'proceder',
        cancel: 'Cancelar',
        accept: 'Aceptar',
        reject: 'rechazar',
        show_in_new_window: 'Mostrar en una nueva ventana',
        checkout: 'verificar',
        external_link_warning: {
            title: 'Enlace externo',
            content: 'Está a punto de abandonar este sitio.',
            question: '¿Desea continuar a la siguiente URL?',
        },
        add: 'agregar',
        date: 'fecha',
        search: {
            save_new: 'Guardar una nueva búsqueda',
            instructions: 'Guarde su búsqueda para usarlo nuevamente más tarde.',
            name: 'nombre',
            none_stored: 'Todavía no tienes búsquedas guardadas.',
            stored: 'Búsquedas guardadas',
            events: 'eventos',
            organizations: 'organizaciones',
            paginate: 'por página',
            page: 'página',
            view: 'vista',
            filters: 'filtros',
            delete: 'borrar',
            views: {
                grid: 'red',
                list: 'lista',
                agenda: 'orden del día',
                monthlist: 'lista de mensajes',
            },
            filter_labels: {
                name: 'nombre',
                location: 'ubicación',
                dance_styles: 'estilos de baile',
                music_styles: 'estilos musicales',
                event_categories: 'categorías de eventos',
                date_filter: 'fecha',
                favorites: 'favoritas',
                country_codes: 'códigos de país',
                organization_type: 'tipos de organización',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'sitio web',
            linkedin: 'LinkedIn',
            youtube: 'YouTube',
            tiktok: 'Tiktok',
            reddit: 'reddit',
            pinterest: 'Pinterest',
            twitter: 'incógnita',
            spotify: 'spotify',
            soundcloud: 'soundcloud',
            facebook_event: 'Evento de Facebook',
            whatsapp: 'whatsapp',
        },
        description: {
            title: 'descripción',
            show_more: 'mostrar más',
            show_less: 'mostrar menos',
        },
        map: 'mapa',
        gmap_block: {
            title: 'mapa',
            location_name: 'Nombre de ubicación'
        },
        spotify_block: {
            title: 'spotify',
        },
        soundcloud_block: {
            title: 'soundcloud',
        },
        paginate: {
            results: 'resultados',
            filter: 'filtrar',
            open_filter: 'filtro abierto',
        },
        edit: 'editar',
        create: 'crear',
        expand: 'más',
        more_info: 'Más información',
        collapse: 'menos',
        unique_impressions: 'Impresiones únicas',
        close: 'cerca',
        save_changes: 'Guardar cambios',
        update_changes: 'Guardar cambios',
        scrollright: 'Desplácese a la derecha para obtener más detalles.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'navegación',
        cta: 'Crear evento',
    },
    date: {
        from: 'de',
        to: 'a',
    },
    report: {
        event: 'evento de informe',
        organization: 'organización de informes',
        name: 'nombre',
        location: 'ubicación',
        date: 'fecha',
        success: 'Su informe ha sido enviado con éxito.',
        not_logged_in: 'Cuenta requerida',
        tooltip: 'informe',
        status: {
            warning: {
                title: 'Actualizar el estado del informe',
                body: '¿Está seguro de que desea cambiar el estado de este informe?'
            }
        },
        archive: {
            warning: {
                title: 'informe de archivo',
                body: '¿Seguro que desea archivar este informe? No se puede deshacer.'
            }
        }
    },
    form: {
        save: 'ahorrar',
        save_and_verify: 'Guardar y verificar',
        too_many_requests: 'Has alcanzado el límite de mensajes. Espera unos minutos antes de enviar otra solicitud.',
    },
    form_subject: {
        general_inquiry: "consulta general",
        technical_support: "apoyo técnico",
        issue_event_submission: "emisión de presentación de eventos",
        issue_account_login: "Cuenta o problema de inicio de sesión",
        question_billing_payment: "Pregunta de facturación o pago",
        report_issue: "informar un problema",
        suggest_feature: "sugerencia de características",
        other: "otra"
    },
    api: {
        general: {
            validation_error: 'error de validación',
            permission_denied: 'permiso denegado',
            success: 'éxito',
        },
        auth: {
            unauthorized: 'No está autorizado a acceder a este recurso.',
            blocked: 'Your account has been blocked, you will not be able to access any features.',
            user_not_found: 'Se requiere una cuenta para usar esta funcionalidad, primero haga una cuenta.',
            email_password_unknown: 'La dirección de correo electrónico o contraseña proporcionada es incorrecta.',
            email_unverified: 'Su dirección de correo electrónico no está verificada.',
            email_already_verified: 'Su dirección de correo electrónico ya está verificada.',
            phone_already_verified: 'your phonenumber is already verified.',
            phone_already_used: 'Este número de teléfono ya está en uso',
            invalid_verification_link: 'El enlace de verificación proporcionado no es válido.',
            email_verified_success: 'Su dirección de correo electrónico ha sido verificada.',
            verification_email_sent: 'Se ha enviado un enlace de verificación a su dirección de correo electrónico.',
            login_success: 'Has iniciado sesión con éxito.',
            logout_success: 'Has registrado con éxito.',
            registration_success: 'Te has registrado con éxito.',
            failed: 'Estas credenciales no coinciden con nuestros registros.',
            password: 'La contraseña proporcionada es incorrecta.',
            throttle: 'Demasiados intentos de inicio de sesión.',
            user_updated_success: 'Su cuenta se ha actualizado con éxito.',
            old_password_incorrect: 'La contraseña antigua proporcionada es incorrecta.',
            password_changed_success: 'Su contraseña se ha cambiado correctamente.',
            user_deleted_success: 'Su cuenta ha sido eliminada con éxito.',
            verification_text_sent: 'Se ha enviado un texto de verificación a su número de teléfono.',
            invite_invalid: 'La URL de invitación usada no es válida.',
            too_many_requests: 'Too many requests. Please try again later.',
            day_limit_exceeded: 'Superó la cantidad máxima de solicitudes de esta funcionalidad hoy.'
        },
        organization: {
            created_success: 'La organización ha sido creada con éxito.',
            authorized_person: {
                created: 'La persona autorizada ha sido creada con éxito.',
                updated: 'La persona autorizada ha sido actualizada con éxito.',
                removed: 'La persona autorizada ha sido eliminada con éxito.',
                not_found: 'No se pudo encontrar la persona autorizada.',
                already_exists: 'La persona autorizada ya existe.',
                role: {
                    singular: 'role',
                    invalid: 'El rol proporcionado no es válido.',
                    eventPublisher: 'editor de eventos',
                    eventCreator: 'creador de eventos',
                    authorizedPerson: 'persona autorizada',
                }
            },
        },
        event: {
            created_success: 'El evento ha sido creado con éxito.',
            deleted_success: 'El evento se ha eliminado con éxito.',
        },
        report: {
            created_success: 'El informe ha sido creado con éxito.',
            invalid_type: 'El tipo de informe proporcionado no es válido.',
        },
        user: {
            updated_success: 'La usuario ha sido actualizada con éxito.',
            search_filter: {
                created: 'creada',
            }
        },
        upload: {
            created_success: 'La carga se ha creado con éxito.',
            deleted_success: 'La carga se ha eliminado con éxito.',
        },
        forms: {
            submitted_success: 'El formulario ha sido enviado con éxito.',
        },
        passwords: {
            reset: 'Su contraseña ha sido reiniciada.',
            sent: '¡Hemos enviado un correo electrónico a su enlace de restablecimiento de contraseña!',
            throttled: 'Espere antes de volver a intentarlo.',
            token: 'Este token de restablecimiento de contraseña no es válido.',
            user: 'No podemos encontrar un usuario con esa dirección de correo electrónico.',
        },
        pagination: {
            previous: '&laquo; Previa',
            next: 'próxima &raquo;',
        },
        dance_style: {
            saved_success: 'El estilo de baile ha sido guardado.',
            deleted_success: 'El estilo de baile se ha eliminado con éxito.',
            deleted_error: 'Error de eliminar el estilo de baile',
            not_found: 'No se pudo encontrar el estilo de baile.',
            parent_not_found: 'No se pudo encontrar el estilo de baile de los padres.',
            suggest_success: 'sugerencia de estilo de baile enviado.',
        },
        music_style: {
            saved_success: 'El estilo musical ha sido guardado.',
            deleted_success: 'El estilo musical se ha eliminado con éxito.',
            not_found: 'No se pudo encontrar el estilo musical.',
            parent_not_found: 'El estilo de la música matriz no se pudo encontrar.',
            suggest_success: 'sugerencia de estilo musical enviado.',
        },
        invite: {
            sent: 'Invitación enviada',
            removed: 'Invitación eliminada',
            resend_success: 'invitación a resentir'
        },
        transfer_request: {
            already_owner: 'Ya eres el propietario de esta organización.',
            organization_already_owns_event: 'La organización ya posee el evento.',
        },
        transferlink: {
            removed: 'Se ha eliminado la línea de transferencia.'
        },
        user_block: {
            create_success: 'User block was successfully created.',
            update_success: 'El bloque de usuarios se actualizó correctamente.',
            delete_success: 'El bloque de usuarios se eliminó correctamente.'
        },
    },
    favorites: {
        favorite: 'favorita',
        like: 'como',
        login_required: 'Debe iniciarse para agregar esto a sus favoritos.',
    },
    likes: {
        login_required: 'Debe iniciar sesión para agregar esto a sus gustos.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'No pudo encontrar al usuario para crear esta organización en nombre de.'
            }
        },
        on_behalf_of: {
            required: 'Se requiere el en nombre del campo.',
        },
        required: 'Este campo es obligatorio.',
        phone: {
            required: 'Se requiere el número de teléfono.',
            regex: 'El número de teléfono no es válido.',
            length: 'El número de teléfono debe tener al menos 10 dígitos de largo.',
        },
        'phone number': {
            required: 'Se requiere el número de teléfono.',
            regex: 'El número de teléfono no es válido.',
            'not-unique': 'Este número de teléfono ya está en uso.',
        },
        number: {
            required: 'se requiere el número.',
            invalid: 'El número no es válido.'
        },
        email: {
            required: 'Se requiere la dirección de correo electrónico.',
            invalid: 'La dirección de correo electrónico no es válida.',
            'not-unique': 'The email addres is not unique.'
        },
        name: {
            required: 'Se requiere el nombre.',
            max_length: 'El nombre es demasiado largo.',
        },
        username: {
            required: 'Se requiere el nombre de usuario.',
            invalid: 'El nombre de usuario no es válido.',
        },
        first_name: {
            required: 'Se requiere el primer nombre.',
        },
        last_name: {
            required: 'Se requiere el apellido.',
        },
        gender: {
            required: 'Se requiere el género'
        },
        city: {
            required: 'Se requiere la ciudad.',
        },
        street: {
            required: 'Se requiere la calle.',
        },
        street_number: {
            required: 'Se requiere el número de la calle.',
        },
        country: {
            required: 'Se requiere el país.',
        },
        brand: {
            required: 'Se requiere la marca.'
        },
        short_description: {
            required: 'Se requiere la breve descripción.',
        },
        long_description: {
            required: 'Se requiere la larga descripción.',
        },
        description: {
            required: 'Se requiere la descripción.',
        },
        type: {
            required: 'se requiere el tipo.',
        },
        message: {
            required: 'Se requiere el mensaje.',
        },
        date_of_birth: {
            required: 'Se requiere la fecha de nacimiento.',
            regex: 'La fecha de nacimiento no es válida.',
            age: 'Debes tener al menos 18 años.',
            old: 'Debes tener como máximo 120 años.'
        },
        date: {
            required: 'se requiere la fecha.',
            regex: 'La fecha no es válida.',
        },
        postal_code: {
            required: 'Se requiere el código postal.',
            length: 'El código postal debe tener al menos 4 dígitos de largo.',
        },
        entrance: {
            required: 'Los precios de las entradas son obligatorios.',
        },
        repeat: {
            required: 'Se requiere la repetición.',
        },
        password: {
            required: 'Se requiere la contraseña.',
            regex: 'Se requiere contraseña válida.',
            confirmed: 'La confirmación de contraseña no coincide.',
            mismatch: 'La contraseña no coincide.',
        },
        conditions: {
            required: 'Debe aceptar los términos y condiciones.',
        },
        url: {
            required: 'Se requiere la URL.',
            regex: 'La URL no es válida.',
        },
        event_category: {
            required: 'Se requiere el tipo de evento.',
        },
        language_code: {
            required: 'Se requiere el idioma.',
        },
        timezone: {
            required: 'La zona horaria es obligatoria.',
        },
        is_public: {
            required: 'Se requiere la visibilidad.',
        },
        form_subject: {
            required: 'Se requiere el sujeto.',
        },
        starts_at: {
            required: 'Se requiere la fecha de inicio.',
            regex: 'La fecha de inicio no es válida.',
        },
        start_date: {
            required: 'Se requiere la fecha de inicio.',
            regex: 'La fecha de inicio no es válida.',
            after_end_date: "La fecha de inicio debe ser antes de la fecha de finalización.",
        },
        start_time: {
            required: 'Se requiere la hora de inicio.',
            regex: 'La hora de inicio no es válida.',
        },
        end_date: {
            required: 'Se requiere la fecha de finalización.',
            regex: 'La fecha de finalización no es válida.',
            before_start_date: "La fecha de finalización debe ser después de la fecha de inicio.",
        },
        end_time: {
            required: 'Se requiere la hora final.',
            regex: 'El tiempo final no es válido.',
        },
        ends_at: {
            required: 'Se requiere la fecha de finalización.',
            regex: 'La fecha de finalización no es válida.',
            before_start_date: "La fecha de finalización debe ser después de la fecha de inicio.",
        },
        registration_opens_at: {
            required: 'Se requiere la fecha de inicio de registro.',
            regex: 'La fecha de inicio de registro no es válida.',
        },
        registration_closes_at: {
            required: 'Se requiere la fecha de finalización de registro.',
            regex: 'La fecha de finalización de registro no es válida.',
        },
        location_type: {
            required: 'Se requiere el tipo de ubicación.',
        },
        location_name: {
            required: 'Se requiere el nombre de ubicación.',
        },
        dance_styles: {
            required: 'Se requieren los estilos de baile.',
        },
        music_styles: {
            required: 'Se requieren los estilos musicales.',
        },
        photos: {
            required: 'Se requiere al menos 1 foto.',
        },
        status: {
            required: 'Se requiere el estado.',
        },
        string: {
            required: '{fieldname} es necesario.',
            mismatch: '"{input}" No coincide "{safeword}".',
        },
        role: {
            required: 'Se requiere el papel.',
        },
        favorite: {
            required: 'se requiere el favorito.',
        },
        dance_style: {
            required: 'Se requiere estilo de baile.',
        },
        facebook: {
            required: 'Se requiere el enlace de Facebook.',
            regex: 'Ingrese un enlace de Facebook válido.',
        },
        facebook_event: {
            required: 'Se requiere el enlace del evento de Facebook.',
            regex: 'Ingrese una URL de evento de Facebook — debe apuntar a facebook.com/events/{id}.',
        },
        instagram: {
            required: 'Se requiere el enlace de Instagram.',
            regex: 'Ingrese un enlace de Instagram válido.',
        },
        website: {
            required: 'Se requiere el enlace del sitio web.',
            regex: 'Ingrese un enlace de sitio web válido.',
        },
        twitter: {
            required: 'Se requiere el enlace X.',
            regex: 'Ingrese un enlace X válido.',
        },
        linkedin: {
            required: 'Se requiere el enlace de LinkedIn.',
            regex: 'Ingrese un enlace válido de LinkedIn.',
        },
        youtube: {
            required: 'Se requiere el enlace de YouTube.',
            regex: 'Ingrese un enlace de YouTube válido.',
        },
        spotify: {
            required: 'Se requiere el enlace de Spotify.',
            invalid: 'Ingrese un enlace de Spotify válido en el formato correcto.',
            regex: 'Ingrese un enlace de Spotify válido en el formato correcto.',
        },
        soundcloud: {
            required: 'Se requiere el enlace de SoundCloud.',
            invalid: 'Ingrese un enlace de SoundCloud válido en el formato correcto.',
            regex: 'Ingrese un enlace de SoundCloud válido en el formato correcto.',
        },
        doesnt_exist: {
            email: 'La dirección de correo electrónico proporcionada no existe.',
            user: 'La usuario proporcionada no existe.',
        },
        djs: {
            required: 'Se requieren las dj.',
        },
        artists: {
            required: 'Las artistas son obligatorias.',
        },
        reason: {
            required: 'Se requiere la razón.'
        },
        default: {
            doesnt_exist: {
                email: 'La dirección de correo electrónico proporcionada no existe.',
                user: 'La usuario proporcionada no existe.',
            }
        }
    },
    brand_activity: {
        by_brand: 'usuario de marca',
        by_admin: 'admin/scraping',
        export: 'Exportar CSV',
    },
    paginatable: {
        headers: {
            last_event_at: 'Última actividad de evento',
            last_event_by: 'Último evento por',
            has_upcoming: 'Próximos publicados',
            id: 'identificación',
            brand_id: 'identificación de marca',
            title: 'título',
            slug: 'babosa',
            group: 'grupo',
            email: 'correo electrónico',
            phone: 'número de teléfono',
            name: 'nombre',
            first_name: 'nombre de pila',
            last_name: 'apellido',
            role_name: 'role',
            role: 'role',
            report: 'informe',
            created_at_formatted: 'creado a',
            status: 'estado',
            actions: 'comportamiento',
            type: 'tipo',
            to_user_email: 'a correo electrónico',
            from_user_email: 'de correo electrónico',
            reason: 'razón',
            organization_name: 'nombre de la organización',
            organization_created: 'organización creada',
            organization_updated: 'Organización Última actualización',
            confirmed_at: 'confirmado en',
            organization_role: 'role',
            sub_dance_styles: 'estilos de danza subterránea',
            sub_music_styles: 'estilos de subs Music',
            city: 'ciudad',
            created_at: 'creada',
            updated_at: 'modificada',
            is_favorite: 'favorita',
            starts_at: 'comienza en',
            tickets_sold: 'boletos vendidos',
            price: 'precio',
            start_date: 'fecha de inicio',
            is_public: 'pública',
            available_tickets: 'boletos disponibles',
            user_id: 'ID de usuario',
            transferable_type: 'tipo',
            content_name: 'título',
            paynl_transaction_id: 'transacción paynl',
            date: 'Fecha de compra',
            amount: 'cantidad total',
            tax_amount: 'impuesto',
            currency: 'divisa',
            description: 'descripción',
            valid_from: 'comenzar',
            valid_until: 'expiración',
            items: 'elementos',
            total: 'total',
            featured: 'presentada',
            created_by: 'usuaria',
            location_type: 'Tipo de ubicación',
            category_id: 'categoría',
            organization_category_id: 'categoría',
            country_code: 'código del país',
            location: 'ubicación',
            info: 'información de usuario',
            owner: 'representante',
            adres: 'DIRECCIÓN',
            export_created: "Exportación creada",
            image_path: "Ruta de la imagen",
            image_alt: "Texto alternativo",
            image_title: "Título de la imagen",
            image: "Imagen",
            order_by: "Ordenar por",
            visibility: "Visibilidad",
            public_status: "Estado público",
            country: 'País',
            activity: 'Actividad',
        },
        search: 'buscar',
        no_records: 'No se encontraron resultados',
    },
    pages: {
        related: 'páginas relacionadas',
        contact: {
            title: 'Póngase en contacto con Latinmap',
            body: 'Para preguntas relacionadas con eventos, comuníquese con la organización que publicó el evento.'
        },
        'how-it-works': {
            title: 'Cómo funciona',
            body: '<p> Venta de boletos en línea a través de Latinmap.com </p><p> Ofrecemos a las organizaciones la posibilidad de ventas de boletos en línea.'
        },
        'goods-and-services': {
            title: 'bienes y servicios',
            body: '<p> Latinmap.com: Descubra y experimente el mundo de la danza latina </p><p> Bienvenido a Latinmap.com, el destino donde obtienes acceso sin esfuerzo a los eventos y experiencias más emocionantes en el mundo de la danza latina.'
        },
        'terms-and-conditions': {
            title: 'Términos y condiciones',
            body: '<p>20230529 Términos y Condiciones de Venta de Entradas</p><p>1. Definiciones</p><p>Los términos aquí definidos con letra mayúscula inicial tienen el siguiente significado en estos Términos y Condiciones:<br/>a. Términos y Condiciones: estas condiciones generales de venta de entradas de la Fundación LatinMap.com<br/>b. Evento: el evento organizado, como un evento de naturaleza musical, cultural, deportiva y/o recreativa, para el cual la Fundación LatinMap.com vende Entradas<br/>c. Organizador del Evento: la persona física o jurídica que produce u organiza un Evento y es responsable del mismo<br/>d. Cliente: la persona física o jurídica que celebra un acuerdo con la Fundación LatinMap.com en relación con un Evento, o a quien la Fundación LatinMap.com hace una oferta para hacerlo<br/>e. Acuerdo: el acuerdo entre la Fundación LatinMap.com y el Cliente para la adquisición de Entradas para Eventos<br/>f. Boleto: el documento que sirve como boleto de admisión para un Evento, incluyendo los Boletos electrónicos</p><p>2. Aplicabilidad</p><p>a. Estos Términos y Condiciones se aplican a todas las ofertas, pedidos, relaciones legales y acuerdos en los que la Fundación LatinMap.com entrega productos o servicios de cualquier tipo al Cliente, incluso si estos productos o servicios no están (más) descritos en estos Términos y Condiciones.<br/>b. La Fundación LatinMap.com rechaza expresamente la aplicabilidad de cualquier otra condición del Cliente.<br/>c. Las partes solo pueden acordar desviaciones de los Términos y Condiciones por escrito. La Fundación LatinMap.com tiene derecho a cambiar los Términos y Condiciones y a declarar términos y condiciones generales modificados aplicables a los Acuerdos. Los términos y condiciones generales modificados se pueden consultar en el sitio web de la Fundación LatinMap.com. d. El Acuerdo está sujeto a los términos y condiciones generales del Organizador del Evento. Si aún no están en posesión del Cliente, el Organizador del Evento enviará los términos y condiciones generales del Organizador del Evento al Cliente si lo solicita.</p><p>3. Formación del Acuerdo</p><p>a. A menos que se acuerde lo contrario por escrito, todas las ofertas, incluidos los anuncios y las listas de precios que se mencionan en el sitio web de la Fundación LatinMap.com, no son vinculantes. b. Al ofrecer y vender entradas, la Fundación LatinMap.com actúa como mediadora en la formación del Acuerdo entre el Comprador y el Organizador del evento. La Fundación LatinMap.com no es parte del Acuerdo que se concluye con la compra de una entrada. El Acuerdo se concluye después de que el Cliente haya comprado una o más entradas a través de la Fundación LatinMap.com. La Fundación LatinMap.com proporciona las entradas en nombre del Organizador del evento. c. Antes de confirmar su reserva, el Cliente siempre debe verificar si se han reservado las entradas correctas. Al realizar la reserva, el Cliente siempre debe utilizar una dirección (de correo electrónico) correcta. Si el Cliente opta por recibir las entradas electrónicamente, el riesgo de pérdida, robo o mal uso de la entrada recae en el Cliente desde el momento en que las entradas le llegan. Si existe alguna duda sobre la exactitud de los datos ingresados ​​por el Cliente al realizar el pedido, la Fundación LatinMap.com puede comunicarse con el Cliente utilizando los datos ingresados ​​por el Cliente. Si la Fundación LatinMap.com no puede comunicarse con el Cliente y, por lo tanto, no puede verificar los datos, la Fundación LatinMap.com puede proceder a cancelar la reserva y vender las Entradas a otro Cliente. Si la Fundación LatinMap.com duda de la exactitud o validez de los datos ingresados ​​por el Cliente al momento de realizar el pedido o del método de pago utilizado por el Cliente, tiene el derecho de cancelar la reserva del Cliente y vender las Entradas a otro Cliente. La Fundación LatinMap.com se esforzará por informar al Cliente en tal caso. Todo Acuerdo se celebra bajo la condición suspensiva de la disponibilidad suficiente de los respectivos productos o servicios.<br/>d. La Fundación LatinMap.com y/o el Organizador del Evento se reservan el derecho de establecer un número máximo de Entradas que se pueden reservar/comprar. Si el Cliente excede este máximo, la Fundación LatinMap.com y/o el Organizador del Evento tienen derecho a deshacer la reserva de las Entradas que superen el número máximo o a invalidar las Entradas en cuestión.<br/>e. Las Entradas no se pueden devolver. A los billetes se les aplica lo dispuesto en el artículo 6:230p sub e BW.</p><p>4. Precios y Pago</p><p>a. La Fundación LatinMap.com vende Entradas en nombre de los Organizadores de Eventos, quienes determinan el precio y el número de asientos disponibles. La información sobre precios y disponibilidad se proporciona sin obligación y está sujeta a cambios.<br/>b. El Cliente paga por los productos o servicios solicitados a través del sitio web, el precio mencionado en el Acuerdo. El pago se realiza en la forma indicada en el sitio web de la Fundación LatinMap.com. Se pueden aplicar condiciones adicionales (de pago/pedido) al pedido.</p><p>c. Todos los precios de la Fundación LatinMap.com mencionados en el sitio web están en euros, incluido el IVA, a menos que se indique expresamente lo contrario.<br/>d. La Fundación LatinMap.com cobra tarifas de servicio por cada pedido. Además, la Fundación LatinMap.com cobra tarifas de administración calculadas en función del monto total de la transacción.</p><p>e. Si el Cliente no paga los montos adeudados a tiempo, el Cliente está obligado, sin necesidad de ninguna demanda o notificación de mora, a pagar intereses legales sobre el monto pendiente. Si el Cliente sigue siendo negligente en la resolución de la reclamación tras una demanda o notificación de incumplimiento, la Fundación LatinMap.com puede ceder la reclamación, en cuyo caso el Cliente también está obligado a reembolsar todos los costos judiciales y extrajudiciales, incluidos los costos calculados por expertos externos además de los costos legalmente establecidos.</p><p>5. Plazos de entrega</p><p>a. Los billetes se envían a la dirección (de correo electrónico) proporcionada por el Cliente en el momento del pedido. La Fundación LatinMap.com seguirá considerando correcta la dirección (de correo electrónico) proporcionada por el Cliente hasta que el Cliente notifique a la Fundación LatinMap.com una nueva dirección (de correo electrónico). b. Los plazos de entrega establecidos por la Fundación LatinMap.com nunca se considerarán como un plazo estricto a menos que se acuerde expresamente lo contrario. En caso de entrega fuera de plazo, se deberá notificar por escrito el incumplimiento a la Fundación LatinMap.com.</p><p>c. Exceder cualquier tiempo de entrega no da derecho al Cliente a compensación ni el derecho a cancelar el pedido o a disolver el Acuerdo a menos que el tiempo de entrega se haya excedido a tal punto que sea irrazonable esperar que el Cliente mantenga el Acuerdo.</p><p>d. Con la excepción de la opción de ordenar Boletos electrónicos, las ventas de Boletos a través del sitio web y el centro de llamadas se detienen 8 días antes de la fecha del Evento para darle a la Fundación LatinMap.com la oportunidad de seguir enviando los Boletos por correo.</p><p>6. Eventos Cancelados y Reprogramados</p><p>a. Es responsabilidad del Cliente verificar si un Evento ha sido cancelado o reprogramado y cuál será la nueva hora o ubicación. Aunque Stichting LatinMap.com intentará notificar al Cliente sobre la cancelación después de recibir la información necesaria del Organizador del Evento, Stichting LatinMap.com no puede garantizar que el Cliente será notificado de la cancelación antes de la fecha del Evento. </p><p>b. Stichting LatinMap.com no se hace responsable de los costes que se generen.<br/>c. Las entradas para eventos reprogramados suelen seguir siendo válidas para el evento de reemplazo. Para obtener más información al respecto, el Cliente puede ponerse en contacto con Stichting LatinMap.com a través de nuestra dirección de correo electrónico: mail(at)LatinMap.com. Si un evento se traslada a otra ubicación o fecha, el Organizador del evento puede imponer condiciones para el reembolso del precio de las entradas.<br/>d. Si un evento se cancela o reprograma, el Cliente puede devolver las entradas para este evento de acuerdo con el acuerdo determinado por el Organizador del evento. Para conocer las condiciones pertinentes, le remitimos a los Términos y condiciones generales del organizador del evento. Si el Organizador del evento solicita a Stichting LatinMap.com que reembolse el precio de las entradas al Cliente, Stichting LatinMap.com lo hará después de recibir los fondos correspondientes del Organizador del evento. Los gastos de servicio y administración no se reembolsan.</p><p> 7. Entradas </p><p> a. Las entradas distribuidas por Stichting LatinMap.com son propiedad del Organizador del evento. El Cliente no puede revender una entrada si esto infringe la ley. Además, un Organizador del evento puede prohibir la reventa o el uso comercial de una entrada. El Cliente debe verificar esto en los términos y condiciones generales del organizador, a los que se hace referencia en la Entrada (y durante el proceso de pedido). En caso de (intento de) reventa o uso comercial que infrinja la ley o las condiciones del Organizador del evento, el Organizador del evento tiene derecho a invalidar la Entrada en cuestión y/o imponer una multa al Cliente. A los titulares de pases de acceso no válidos se les negará el acceso al Evento, sin derecho a compensación.<br/>b. Al recibir las Entradas, el Cliente debe verificarlas, ya que los errores no siempre se pueden corregir. Después de la compra, las Entradas no se pueden cambiar ni reembolsar.<br/>c. Si el billete del cliente está tan dañado que ya no se puede verificar su autenticidad, el cliente puede ponerse en contacto con el servicio de atención al cliente en línea.<br/>d. Las solicitudes especiales, como la reserva de plazas para sillas de ruedas, deben comunicarse de forma oportuna y explícita. Stichting LatinMap.com no puede garantizar que se puedan atender las solicitudes especiales. Para obtener más información al respecto, el cliente puede ponerse en contacto con Stichting LatinMap.com a través de nuestra dirección de correo electrónico: mail(at)LatinMap.com </p><p>8. Derechos de propiedad intelectual e industrial </p><p>a. Los derechos de propiedad industrial e intelectual que recaen sobre el billete de Stichting LatinMap.com pertenecen a Stichting LatinMap.com o a su licenciante. El cliente se abstendrá de cualquier acción que pueda vulnerar los derechos u otros intereses de Stichting LatinMap.com o de su licenciante.<br/>b. El Cliente no podrá eliminar ni alterar ninguna indicación de derechos de autor, marcas, nombres comerciales u otros derechos de propiedad intelectual o industrial del Billete, ni realizar ningún cambio en la forma o cualquier otra característica del Billete.<br/>c. El Cliente tiene prohibido falsificar, duplicar o reproducir el Billete de cualquier forma.<br/>d. El Acuerdo no se extiende a la transferencia de ningún derecho de propiedad intelectual de Stichting LatinMap.com al Cliente. </p><p>9. Privacidad </p><p>a. Los datos proporcionados por el Cliente al comprar billetes serán utilizados exclusivamente por Stichting LatinMap.com para mejorar sus servicios.<br/>b. Los datos proporcionados por el Cliente al comprar billetes nunca serán puestos a disposición de terceros. </p><p>c. Los datos proporcionados por el Cliente al comprar billetes estarán a disposición de la Organización vendedora. Es posible que la organización utilice los datos para enviar correos.<br/>d. Esperamos que nuestros clientes manejen esta información con cuidado. En caso contrario, nos gustaría saberlo y se lo comunicaremos al cliente en cuestión y, si lo consideramos necesario, lo excluiremos de la venta de entradas en línea. </p><p>e. Nota: no asumimos ninguna responsabilidad por la política de privacidad de nuestros clientes. </p><p> 10. Responsabilidad </p><p> a. Stichting LatinMap.com no puede ser considerado como el organizador (Organizador del Evento) del Evento y no es responsable ni garantiza la calidad (artística) y el contenido del Evento y el curso de los eventos en o alrededor del Evento, y no acepta ninguna responsabilidad sobre esta base. </p><p> b. Excepto las otras disposiciones de responsabilidad en estos Términos y Condiciones Generales, la responsabilidad total de Stichting LatinMap.com debido al incumplimiento atribuible, o debido a un acto ilegal, se limita a la compensación por daños directos hasta un máximo del monto que se haya cobrado o se pueda cobrar al Cliente por las Entradas, a menos que el daño sea el resultado de dolo y/o negligencia grave de </p><p> Stichting LatinMap.com o sus subordinados.<br/> c. La responsabilidad de Stichting LatinMap.com por el incumplimiento imputable de un contrato solo se produce en todos los casos si el Cliente declara por escrito y de forma oportuna y adecuada el incumplimiento de Stichting LatinMap.com, fijando un plazo razonable para la subsanación del incumplimiento, y Stichting LatinMap.com sigue incumpliendo sus obligaciones imputables incluso después de dicho plazo. La notificación del incumplimiento debe contener una descripción del incumplimiento lo más completa y detallada posible, de modo que Stichting LatinMap.com pueda responder adecuadamente.<br/> d. El Cliente indemnizará a Stichting LatinMap.com frente a todas las reclamaciones de terceros relacionadas con el incumplimiento o el cumplimiento insuficiente por parte del Cliente de cualquier obligación hacia Stichting LatinMap.com, ya sea que surja o no de los Términos y Condiciones Generales.<br/> e. Una condición para la existencia de cualquier derecho a indemnización es siempre que el Cliente informe del daño a Stichting LatinMap.com por escrito lo antes posible después de que se produzca. f. Stichting LatinMap.com no se hace responsable de ningún daño o pérdida de la entrada. En caso de pérdida o robo, el Cliente no podrá reclamar una entrada de sustitución ni el reembolso de ningún importe. Stichting LatinMap.com tampoco se hace responsable de los retrasos o de la falta de entrega o de la entrega incorrecta de las entradas, si el retraso, la falta de entrega o la entrega incorrecta no se pueden atribuir a Stichting LatinMap.com.<br/> g. Stichting LatinMap.com no acepta ningún tipo de responsabilidad por las entradas obtenidas por el Cliente de terceros. Stichting LatinMap.com tampoco puede garantizar su autenticidad.<br/> h. Stichting LatinMap.com no se hace responsable en ningún caso de los daños sufridos por el titular de esta entrada debido a las acciones u omisiones de terceros. </p><p>11. Fuerza mayor </p><p>a. Se entiende por fuerza mayor cualquier incumplimiento que no pueda imputarse a Stichting LatinMap.com, porque no se debe a su culpa y no es imputable a ella ni según la ley, acto jurídico ni según las normas generalmente aceptadas.<br/> b. Sin perjuicio de sus otros derechos, Stichting LatinMap.com tiene derecho a suspender la ejecución del pedido del Cliente en caso de fuerza mayor, notificándolo por escrito al Cliente, y sin que Stichting LatinMap.com esté obligada a ninguna compensación, a menos que esto sea inaceptable según los criterios de razonabilidad y equidad en las circunstancias dadas. </p><p>12. Ley aplicable y tribunal competente </p><p>a. Todos los acuerdos con Stichting LatinMap.com se rigen por la ley holandesa. </p><p> 13. Varios </p><p> a. Los clientes que lleguen tarde al evento serán admitidos, en la medida de lo posible, en los momentos adecuados del evento. Sin embargo, no se puede garantizar la entrada.<br/> b. Cuando estos Términos y Condiciones Generales obliguen a Stichting LatinMap.com a realizar una comunicación por escrito, Stichting LatinMap.com tiene derecho a realizar esta comunicación electrónicamente, como por ejemplo, pero no limitado a, un mensaje de correo electrónico o fax.<br/> c. Los errores evidentes y los errores tipográficos en el sitio web de Stichting LatinMap.com o en cotizaciones, confirmaciones de pedidos, entradas y/u otros documentos, no vinculan a Stichting LatinMap.com. d. En caso de desacuerdo entre Stichting LatinMap.com y el Cliente con respecto a la traducción y/o interpretación de los Términos y Condiciones Generales, la versión en holandés de los mismos será decisiva.<br/> e. Si una o más de las disposiciones de estos Términos y Condiciones Generales o cualquier otro acuerdo con Stichting LatinMap.com entraran en conflicto con cualquier requisito legal aplicable, la disposición pertinente será nula y será reemplazada por una nueva disposición comparable legalmente permisible que será determinada por Stichting LatinMap.com.</p>'
        },
        'privacy-policy': {
            title: 'política de privacidad',
            body: '<p> Política de privacidad para Latinmap.com: Descubra y experimente el mundo de la danza latina <br> Última actualización: 23-05-2023 <br> Gracias por visitar Latinmap.com, el destino para descubrir y experimentar el mundo de la danza latina.'
        },
        about: {
            'about-latin-scene': {
                title: "Sobre la escena latina",
                body: "La escena de la danza latina es una comunidad vibrante y diversa que celebra el rico patrimonio cultural de América Latina a través de la música, la danza y el arte."
            },
            salsa: {
                title: "salsa",
                body: "La salsa es una forma popular de danza social que se originó en el Caribe."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata es un género de música latinoamericana que se originó en la República Dominicana en la primera mitad del siglo XX con elementos musicales europeos, indígenas y africanos."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk es un estilo rápido de música rítmica de la música rítmica que se origina en las islas caribeñas de Guadalupe y Martinica, popularizado por las Antillas Francesas Kassav \'en la década de 1980."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba es un género musical y un estilo de baile que se origina en Angola a fines de los años setenta y principios de los ochenta."
            },
            cuban: {
                title: "cubana",
                body: "La música y el baile cubanos están profundamente arraigados en el diverso patrimonio cultural de la isla, combinando influencias africanas, españolas e indígenas."
            }
        },
        'help-center-faq': {
            title: 'Centro de ayuda',
        },
        'cookie-policy': {
            title: 'Política de cookies',
        },
        'create-an-event': {
            title: 'Cómo crear un evento',
        },
        'create-an-brand-or-an-organization': {
            title: 'Cómo crear una marca',
        },
        'become-an-ambassador': {
            title: 'convertirse en embajador',
        },
        'promote-your-event': {
            title: 'Cómo promocionar tu evento',
        },
        'professional-account-verification': {
            title: 'Verificación de cuenta profesional'
        },
        'about-us': {
            title: 'Sobre nosotros',
        },
    },
    email: {
        'not-unique': 'El correo electrónico ya ha sido tomado.',
    },
    leads: {
        title: 'enviar plomo',
        description_p1: '¿Eres usuario de LatinMap y encontraste una escuela de baile, organización o evento que aún no está listado? Envíalo aquí — tu contribución nos ayuda a mantener la plataforma completa, precisa y valiosa para bailarines de todo el mundo.',
        description_p2: '¿Eres organizador y quieres aparecer en LatinMap? ¡Crea una Cuenta Pro y añade tus actividades a la plataforma de forma gratuita!',
        description_p3: 'Gracias por ayudarnos a hacer crecer LatinMap, la plataforma que conecta a la comunidad global de baile.',
        plural: 'dirige',
        type: {
            event: 'evento',
            organization: 'organización',
            label: 'tipo',
        },
        name: 'nombre',
        address: 'DIRECCIÓN',
        country: 'país',
        city: 'ciudad',
        street: 'calle',
        street_number: 'número de calle',
        dance_styles: 'estilos de baile',
        music_styles: 'estilos musicales',
        photos: 'fotos',
        category: 'tipo de evento',
        location_name: 'nombre del lugar',
        location_type: {
            singular: 'Tipo de ubicación',
            online: 'virtual',
            offline: 'en persona',
        },
        timezone: 'zona horaria',
        date: 'fecha',
        not_posted_by_ambassador: 'Verificada por la organizadora',
        undercondition: 'bajo condición',
        warning: 'cambio importante',
        cancelled: 'cancelada',
        posted_by_ambassador: 'Publicado por latinmap embajadora',
        upcoming: 'próximos eventos',
        status_options: {
            active: 'activa',
            canceled: 'cancelada',
            pending: 'todavía no confirmado',
            changed: 'cambio importante',
            submitted: 'enviada',
            under_review: 'bajo revisión',
            implemented: 'implementada',
            declined: 'rechazada',
        },
        submit: 'entregar',
        success: 'El plomo ha sido presentado.',
        filter_type: 'Filtrar por tipo',
        view: 'dirigir',
        confirm_delete: 'Eliminar el plomo',
        delete_confirmation: '¿Estás seguro de que quieres eliminar este liderazgo?',
        deleted_successfully: 'El plomo se ha eliminado con éxito.',
        error_loading: 'Error de carga de cables',
        status_updated: 'El estado principal se ha actualizado.',
        error_status: 'Error de actualización del estado del plomo',
    },
    search: {
        allOragnisations: 'Ver todas las escuelas de baile',
        allEvents: 'Ver todos los eventos',
        searchresult: 'Resultados de la búsqueda',
        type: 'Tipo',
        title: 'título',
        city: 'ciudad',
        country: 'país',
        address: 'DIRECCIÓN',
        startdate: 'fecha de inicio',
        favorite: 'favorita'
    },
    components: {
        picture_input: {
            drag: "Subir avatar",
            remove: 'Eliminar avatar',
            change_avatar: 'Cambiar avatar'
        },
        pictureInput: {
            drag: "Haga clic aquí para cargar una imagen",
            change: "Cambiar",
            remove: "Eliminar",
            upload: "Subir",
            tap: "Toca para subir",
            select: "Seleccionar archivo",
            selected: "Seleccionado",
            fileSize: "Tamaño del archivo",
            fileType: "Tipo de archivo",
            aspect: "Relación de aspecto",
        },
    },
    passion: {
        title: "Siente el Ritmo, Únete al Movimiento",
        subtitle: "Descubre el vibrante mundo de la danza latina. Conecta con bailarines, encuentra eventos cerca de ti y deja que la música mueva tu alma.",
    },
    payment: {
        received: "pago recibido",
        thank_you: "¡Gracias por tu compra!",
        download_ticket: "Descargar Ticket (s)",
        download_button: "Descargar Ticket (s)",
        email_check: "Consulte su bandeja de entrada, incluida la carpeta de spam, para obtener un correo electrónico de nuestro sistema de boletos.",
        failed: "pago pendiente",
        failed_message: "Desafortunadamente, encontramos un problema para procesar su pago.",
        download_invoice: "Descargar factura",
        download_invoice_button: "Descargar factura",
        invoice_check: "Consulte su bandeja de entrada para ver su factura.",
        thank_you_for_purchase: "¡Gracias por comprar el evento destacado!",
    },
    financial_center: {
        financial_dashboard: 'Mi tablero financiero',
        title: "centro financiero",
        description: "Administre sus transacciones, pagos, promociones y características premium.",
        overview: "descripción general",
        transactions: "actas",
        payoutsettings: "Configuración de pago",
        featured_events: "eventos destacados",
        ticketsales: "venta de entradas",
        premium: "cuentas premium",
    },
    inputfield: {
        select_here: 'Seleccione aquí',
    },
    tooltip: {
        edit: 'Editar',
        delete: 'Eliminar',
        view: 'Ver',
        hide: 'Ocultar',
        under_construction: 'En construcción',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Algo salió mal. Inténtalo de nuevo en un momento.",
        confirm: {
            title: "¿Dejar de recibir estos correos?",
            body: "Ahora recibes estos correos automáticos en {email}.",
            note: "Los mensajes sobre tu cuenta, como restablecer la contraseña, se seguirán enviando.",
            button: "Dejar de recibirlos",
        },
        done: {
            title: "Ya no recibirás nada",
            body: "No enviaremos más correos automáticos a {email}.",
            undo: "Volver a recibirlos",
        },
        unknown: {
            title: "Este enlace ya no funciona",
            body: "El enlace no es válido. Usa el enlace de un correo más reciente.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Enviar un evento',
        title: 'Envía tu evento a LatinMap',
        title_brand: 'Enviar un evento para {brand}',
        lede: 'Rellena lo que sepas. Lo preparamos y lo publicamos tras una breve revisión.',
        loading: 'Un momento…',
        notes: {
            no_account: 'No hace falta cuenta — este enlace basta',
            checked: 'Revisamos cada evento antes de publicarlo',
            reply: 'Si algo no queda claro, te escribimos',
        },
        sections: {
            event: 'El evento',
            where: 'Dónde',
            details: 'Detalles',
            you: 'Sobre ti',
        },
        fields: {
            name: 'Nombre del evento',
            organizer_name: 'Nombre del organizador / marca',
            organizer_url: 'Web o redes sociales del organizador',
            start_date: 'Fecha',
            start_time: 'Hora de inicio',
            end_date: 'Fecha de fin',
            end_time: 'Hora de fin',
            dance_styles: 'Estilos de baile',
            event_category: "Tipo de evento",
            event_category_placeholder: "Elige un tipo de evento",
            location_name: 'Lugar',
            city: 'Ciudad',
            country: 'País',
            country_placeholder: 'Elige un país',
            short_description: 'Descripción breve',
            description: 'Descripción completa',
            link: 'Enlace con más información o entradas',
            photo: "Foto",
            photo_remove: "Quitar foto",
            your_name: 'Tu nombre',
            your_email: 'Tu correo electrónico',
        },
        hints: {
            organizer:
                '¿Quién organiza este evento? Un enlace a su web o Instagram nos ayuda a encontrar la marca correcta.',
            end_date: "Para un evento de un día es la misma fecha que el inicio.",
            contact: 'Solo lo usamos para contactarte sobre este evento.',
            photo: "Opcional. JPG, PNG o WebP, hasta 8 MB.",
        },
        errors: {
            name: 'Escribe el nombre del evento.',
            start_date: 'Indica la fecha.',
            end_date: "Indica la fecha de fin.",
            event_category: "Elige un tipo de evento.",
            too_many: "Lo has intentado demasiadas veces. Espera un momento y vuelve a intentarlo.",
            city: 'Indica la ciudad.',
            country: 'Elige un país.',
            organizer_name: 'Indica quién organiza este evento.',
            email: 'Escribe un correo electrónico válido.',
            failed: 'No se pudo enviar. Inténtalo de nuevo en un momento.',
            photo_type: "Elige un JPG, PNG o WebP.",
            photo_size: "Esta foto es demasiado grande. Hasta 8 MB.",
        },
        submit: 'Enviar evento',
        done: {
            title: 'Gracias, ya tenemos tu evento',
            body: 'Alguien de LatinMap lo revisará. Recibirás una confirmación por correo.',
            again: 'Enviar otro evento',
        },
        invalid: {
            title: 'Este enlace ya no funciona',
            body: 'El enlace caducó o se retiró. Pide uno nuevo a quien te lo envió.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Mantente cerca de la escena',
            lede: 'Recibe los eventos de baile latino por los que vale la pena dejar la noche libre: fiestas, festivales, talleres y clases de prueba, además de novedades y sorteos de LatinMap.',
            benefits: {
                agenda: 'La agenda, antes que nadie',
                festivals: 'Festivales y congresos por los que merece la pena viajar',
                features: 'Nuevas funciones de LatinMap en cuanto salen',
                community: 'Sorteos y noticias de la comunidad',
            },
            form_title: 'Suscríbete',
            email_label: 'Tu correo electrónico',
            submit: 'Apúntame a la lista',
            terms: 'Un correo cada vez, y tu dirección nunca va a nadie más. Puedes darte de baja con un clic, en cada mensaje.',
            done: {
                title: 'Revisa tu bandeja de entrada',
                body: 'Te hemos enviado un correo. Haz clic en el enlace para confirmar y ya estarás en la lista.',
                again: 'Suscribir otra dirección',
            },
        },
        confirmed: {
            title: 'Suscripción confirmada',
            success: 'Tu suscripción está confirmada. ¡Bienvenido!',
            body: 'A partir de ahora recibirás el boletín de LatinMap: los mejores eventos de baile latino directamente en tu bandeja de entrada. Puedes darte de baja con un clic en cualquier boletín.',
            discover_events: 'Descubrir eventos',
            back_home: 'Volver al inicio',
        },
    },
    footer: {
        section_1: {
            title: 'Discover LatinMap',
            about: 'Sobre nosotros',
            how_it_works: 'Cómo funciona',
            search: 'Buscar',
            contact: 'Contáctenos',
        },
        section_2: {
            title: 'Soporte y Comunidad',
            help: 'Centro de ayuda',
            privacy_policy: 'política de privacidad',
            terms_and_conditions: 'Términos y condiciones',
            cookie_policy: 'Política de cookies',
        },
        section_3: {
            title: 'para profesionales',
            create_event: 'Cómo crear un evento',
            create_organization: 'Cómo crear una marca',
            become_ambassador: 'convertirse en embajador',
            promote_event: 'Cómo promocionar tu evento',
            professional_account_verification: 'Verificación de cuenta profesional'
        },
        section_4: {
            title: 'Categorías de danza y eventos',
            all_events: 'Todos los eventos',
        },
        follow_our_socials: 'Sigue nuestras redes sociales',
    }
};
